import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';

 export const loginUser = createAsyncThunk(
    'auth/loginUser',
    async (data) => {
        let url = baseUrl+'login';
      try {
        const response = (await axios.post(url,data)).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error"){
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );
  
  // export const signUp = createAsyncThunk(
  //   'auth/signUp',
  //   async (data) => {
  //       let url = baseUrl+'signup';
  //     try {
  //       const response = (await axios.post(url,data)).data
  //       if(response.status === "success"){
  //           return Promise.resolve(response)
  //       } else {
  //           return Promise.reject(response)
  //       }
  //     } catch (err) {

  //       return Promise.reject(err)
  //     }
  //   },
  // );

  export const signUp = createAsyncThunk(
  'auth/signUp',
  async (data, { rejectWithValue }) => {
    const url = baseUrl + 'signup';
    try {
      const response = await axios.post(url, data);
      const resData = response.data;

      // API hit successful, but custom error
      if (resData.status !== 'success') {
        return rejectWithValue(resData);
      }

      return resData; 
    } catch (err) {
      // Network or server failure
      const errorData = err?.response?.data || { message: "Unknown error occurred" };
      return rejectWithValue(errorData);
    }
  }
);

  export const LogOut = createAsyncThunk(
  'auth/logOut',
  async (data, { rejectWithValue }) => {
    const url = baseUrl + 'logOut';
    try {
      const response = await axios.post(url, data);
      console.log("Hey: ", response);
      const resData = response.data;

      if (resData.status === 'error') {
        return rejectWithValue(resData);
      }

      return resData;
    } catch (err) {
      const errorData = err?.response?.data || { message: "Unknown error occurred" };
      return rejectWithValue(errorData);
    }
  }

  
);
